import { FC } from 'react';

import { PERFOMANCE_CARD_TEST_IDS } from '../../../constants/data-testids';
import { Card, CardContent } from '../../atoms/Card/Card';
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

export const PerformanceCardSkeleton: FC = () => {
  return (
    <Card data-testid={PERFOMANCE_CARD_TEST_IDS.SKELETON} className="border select-none bg-white">
      <CardContent className="flex flex-col">
        <div className="flex items-center justify-between gap-2 min-h-[18px] mb-2">
          <Skeleton className="h-[14px] w-[188px] rounded-sm" />
        </div>

        <div className="mb-9 flex items-center gap-2">
          <div className="flex flex-col">
            <div className="flex items-center gap-2 min-h-[24px]">
              <Skeleton className=" h-[14px] w-[60px] rounded-sm" />
              <Skeleton className=" h-[14px] w-[30px] rounded-sm" />
            </div>
            <div className="flex items-center gap-2 min-h-[24px]">
              <Skeleton className="h-[14px] w-[30px] rounded-sm" />
              <Skeleton className="h-[14px] w-[200px] rounded-sm" />
            </div>
          </div>
        </div>

        <div className="relative w-full">
          <Skeleton className="h-[14px] w-full rounded-sm" />
        </div>
      </CardContent>
    </Card>
  );
};
